import { createTheme } from '@mui/material/styles'
import { theme as baseTheme } from '@chilecompra/react-kit/styles'

const theme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    charts: {
      apple: '#388E3C',
      bondiBlue: '#0097A7',
      burntSienna: '#EA7D5A',
      cinnabar: '#E64A19',
      cobalt: '#0047B3',
      creamBrulee: '#FDDF96',
      darkenCreamBrulee: '#FDE2A0',
      darkenMacNcheese: '#FAC48D',
      darkenSpray: '#8DD0D7',
      darkenTonysPink: '#F3AD97',
      darkenWisteria: '#C49AD5',
      darkRed: '#F44336',
      deepSaffron: '#F49330',
      denim: '#1976D2',
      dodgerBlue: '#1E88E5',
      fauxRoyal: '#002866',
      forestGreenCrayola: '#5DA260',
      grape: '#8E24AA',
      jacksonsPurple: '#1A237E',
      liberty: '#5662AF',
      lightenNavyBlue: '#66A2FF',
      lightSlate: '#768AA2',
      macNcheese: '#FABD80',
      midnight: '#001C41',
      moodyBlue: '#7986CB',
      navyBlue: '#0064FF',
      orangeYellowCrayola: '#F9CF68',
      purpleHeart: '#5E35B1',
      purpureus: '#9249B1',
      ruby: '#D81B60',
      saffron: '#FBC02D',
      seance: '#7B1FA2',
      shadeBlue: '#3F51B5',
      spray: '#80CBD3',
      tangerine: '#F57C00',
      teal: '#00897B',
      toryBlue: '#303F9F',
      tonysPink: '#F2A48C',
      white: '#FFFFFF',
      tuftsBlue: '#448ED8',
      wisteria: '#BD8FD0',
      black1: '#2E384D',
      gray: '#F3F5F7'
    },
    custom: {
      alto: '#D8D8D8',
      caribbeanGreen: '#00BD9B',
      chathamsBlue: '#0F4980',
      corduroy: '#585959',
      regalBlue: '#044076',
      zumthor: '#E5EFFF',
      transparentBlack: '#0000001a',
      transparentWhite: '#FFFFFF00',
      gradientBlack: '#000000cc',
      yellowStar: '#FFD700',
      pastelBlue: '#CCE0FF',
      gray: '#D1D8E0',
      textGray: '#536479'
    }
  },
  typography: {
    ...baseTheme.typography,
    coda: ['Coda', 'cursive'].join(',')
  }
})

export default theme
